module.exports = __webpack_public_path__ + "static/media/squarePanel3.20cd6187.svg";